import * as React from 'react';
import { useFormContext, type FieldPath, type FieldValues } from 'react-hook-form';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from './Form';
import { Textarea } from '@/components/ui/textarea';

interface FormTextareaProps<TValues extends FieldValues>
  extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'name' | 'form'> {
  name: FieldPath<TValues>;
  label?: React.ReactNode;
  description?: React.ReactNode;
}

export function FormTextarea<TValues extends FieldValues>({
  name,
  label,
  description,
  ...textareaProps
}: FormTextareaProps<TValues>) {
  const { control } = useFormContext<TValues>();
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          {label !== undefined && <FormLabel>{label}</FormLabel>}
          <FormControl>
            <Textarea
              {...textareaProps}
              {...field}
              value={(field.value as string | undefined) ?? ''}
            />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
